<template>
  <fragment>
    <Base :style="[styles]">
    <div
      :data-size="data.audio.size"
      preload="metadata"
    >
      <div class="wrapper">
        <Aud :style="layout" :data="data"></Aud>
      </div>
    </div>
    </Base>
  </fragment>
</template>

<script>
import Base from './Base'
import Aud from '@/components/Aud'
import utils from '@/mixins/utils'

export default {
  name: 'Audio',

  mixins: [utils],

  components: {
    Base,
    Aud
  },
  extends: Base,

  props: {
    data: {
      type: Object,
      default: () => {
        return null
      }
    }
  },

  mounted() {
    if (
      this.$parent.$el.classList[0] !== 'module' &&
      this.data.audio.size === 'small'
    ) {
      this.$el.remove()
    }
  },

  computed: {
     layout() {
      if (this.data.audio.custom_layout) {
        return this.grid(this.data.audio.columns)
      } else {
        return this.grid('3,10')
      }
    }
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  @include grid-container-responsive;
}
</style>
